export default {
  API_ENDPOINT: process.env.REACT_APP_API_BASE || 'http://localhost:8000/api'
}
